import axios from "axios";

axios.defaults.headers.common["Accept-Language"] = "ko-KR";

const bsHost = process.env.REACT_APP_BS_HOST || "";
const mngHost = process.env.REACT_APP_MNG_HOST || "";

const parseKeyValueCollection = (payload: DynamicJsonTypes) => {
  const ret = Object.entries(def(payload))
    .map(([key, value], idx) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");

  return ret;
};

const parseFormData = (payload: DynamicJsonTypes) => {
  const data = { ...def(payload), files: payload.files };
  const formData = new FormData();
  Object.entries(data).map(([key, value], idx) => {
    if (key === "files") {
      Object.entries(value).map(([key2, value2], idx2) => {
        formData.append("files", value2 as File);
      });
    } else {
      formData.append(key, value);
    }
  });

  return formData;
};

const def = (payload: DynamicJsonTypes): DynamicJsonTypes => {
  return JSON.parse(JSON.stringify(payload));
};

export { bsHost, mngHost, parseKeyValueCollection, parseFormData, def };
export default axios;
